import CardGrey from "../../../common/CardGrey"
import ItemSimple from "../Shared/ItemSimple"
import DownloadDocument from "./DownloadDocument"
import { formatDate } from "../../../../lib/script"
import DefaultUpdater from "../../../common/DefaultUpdater"

import classes from '../Shared/Item.module.css'
import { frontendOptions } from "../../../../lib/systemData"


const CrimeVictimItem = ({itemData, apiCase}) => {

    let merge_before_update ={
        put_in: 'object',
        items: [
            {
                value_flag: true,
                fields_to_modify: [
                    {
                        field: 'date',
                        value: formatDate(new Date()),
                    }
                ]
            },
            {
                value_flag: false,
                fields_to_modify: [
                    {
                        field: 'approved',
                        value: null,
                    },
                    {
                        field: 'appealed',
                        value: null,
                    },
                    {
                        field: 'exhausted',
                        value: null,
                    }
                ]
            }
        ],
    
    }

    let merge_before_update_approved = {
        put_in: 'object',
        items: [
            {
                value_flag: 'in_all_cases',
                fields_to_modify: [
                    {
                        field: 'exhausted',
                        value: null,
                    },
                    {
                        field: 'appealed',
                        value: null,
                    }
                ]
            }
        ]
    }  

    return <ItemSimple data={itemData} mainItem={null} type={apiCase} folder={'crime_victim'}>
        <div className={classes.item_inner}>
            <div className={classes.item_left}>
                <div >
                    <div className={classes.row}>
                        <div className={classes.row_item_full}>
                            <CardGrey >
                                <div className={`${classes.flex_container} ${classes.gap_16} ${classes.space_betwen}`} >
                                    <div className={`${classes.flex_container} ${classes.gap_16}`}>
                                        <DefaultUpdater type={'checkbox'} value={itemData.filled_by_patient} name={'filled_by_patient'} label={'Application Filled by Patient'} identifier={{type: apiCase, field: 'filled_by_patient', type_id: itemData.id, folder: 'crime_victim'}} extraOptions={{direction: 'reverse'}}/>
                                    </div>
                                    <div className={`${classes.flex_container} ${classes.gap_16}`}>
                                        <DownloadDocument label={'Application'} pdfSlug={'crime_victim_application'} itemId={itemData.id} apiCase={apiCase} url={itemData.crime_victim_application}/>
                                    </div>
                                </div>
                            </CardGrey>
                        </div>                        
                    </div>

                    {(itemData.filled_by_patient != 0 && itemData.filled_by_patient ) && <>
                        <div className={classes.row}>
                            <div className={classes.row_item_full}>
                                <CardGrey>
                                    <div className="flex-container-equal">
                                        <DefaultUpdater type={'checkbox'} value={itemData.submitted} name={'submitted'} label={'Application Submitted'} identifier={{type: apiCase, field: 'submitted', type_id: itemData.id, folder: 'crime_victim'}} extraOptions={{direction: 'reverse'}} merge_before_update={merge_before_update}/>

                                        <DefaultUpdater type={'date'} value={itemData.date} label={'Date'} identifier={{type: apiCase, field: 'date', type_id: itemData.id, folder: 'crime_victim'}}/>

                                        <DefaultUpdater type={'input'} value={itemData.case_number} name={'case_number'} label={'Case Number'} identifier={{type: apiCase, field: 'case_number', type_id: itemData.id, folder: 'crime_victim'}} />

                                        <DefaultUpdater type={'curency'} value={itemData.amount_submitted} name={'amount_submitted'} label={'Amount of Statement Submitted ($)'} identifier={{type: apiCase, field: 'amount_submitted', type_id: itemData.id, folder: 'crime_victim'}} extraOptions={{fullBox: true}}/>
                                    </div>
                                </CardGrey>
                            </div>                        
                        </div>                    

                        {itemData.submitted ? <div className={classes.row}>
                            <div className={classes.row_item_full}>
                                <CardGrey>
                                    <div className={`${classes.flex_container} ${classes.gap_16} ${classes.space_betwen}`}>
                                        <div className={`${classes.flex_container} ${classes.gap_16}`}>
                                            <DefaultUpdater type={'radio'} value={itemData.approved} options={frontendOptions()?.aplicationApprovedDeniedFields} name={'approved'} identifier={{type: apiCase, field: 'approved', type_id: itemData.id, folder: 'crime_victim'}} extraOptions={{normalSize: true}} merge_before_update={merge_before_update_approved}/>
                                            
                                            {(itemData.approved == 1) && <DefaultUpdater type={'checkbox'} value={itemData.exhausted} name={'exhausted'} label={'Exhausted'} identifier={{type: apiCase, field: 'exhausted', type_id: itemData.id, folder: 'crime_victim'}} extraOptions={{direction: 'reverse'}}/>}
                                            {(itemData.approved == 0) && <DefaultUpdater type={'checkbox'} value={itemData.appealed} name={'appealed'} label={'Application Appealed'} identifier={{type: apiCase, field: 'appealed', type_id: itemData.id, folder: 'crime_victim'}} extraOptions={{direction: 'reverse'}}/>}
                                        </div>
                                        <DownloadDocument label={'Appeal'} pdfSlug={'crime_victim_appeal'} itemId={itemData.id} apiCase={apiCase} url={itemData.crime_victim_appeal}/>
                                    </div>
                                </CardGrey>
                            </div>                        
                        </div> : ''}
                    </>}        
                </div>
                
            </div>                
        </div> 
    </ItemSimple>
}

export default CrimeVictimItem